import { forwardRef, useCallback, useImperativeHandle } from 'react';

/**
 * Stub: not implemented.
 */
export const AdyenProvider = forwardRef((_props, ref) => {
  const processPayment = useCallback(
    async (_data: any) =>
      new Promise(r => {
        r(undefined);
      }),
    [],
  );

  useImperativeHandle(ref, () => ({ processPayment }), [processPayment]);

  return null;
});
